// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getInsurances = (state: ReduxStateShared) => state.insurances.insurances || [];

export const getSelectedInsuranceID = (state: ReduxStateShared) => state.insurances.selectedInsuranceID;
